exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1AQML{border-color:#007a6e;background-color:#ebf6f5;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._1AQML,._1AQML span{color:#1b5e20}._1AQML button{width:200px;background-color:#007a6e;border-color:#007a6e}._1AQML button:hover{width:200px;background-color:#005d54;border-color:#005d54;cursor:pointer}._1C4VS{color:#363636;background-color:#f3f3f3;border-color:#ef6d11;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

// exports
exports.locals = {
	"success": "_1AQML",
	"warning": "_1C4VS"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Telemedicina/TurnosSolicitudAlert/TurnosSolicitudAlert.css
// module id = 1253
// module chunks = 0 1